
export function ImageSelector(GUID) {

    let labLogoPath = '';
  
    switch (GUID) {
  
  
      case "3A54636D-B994-4228-A61F-82CDEAA9DF31":
  
        // labLogoPath = './LabIcons/lablogo_atiehmashhad_login.png';
        labLogoPath =  './lablogo_atiehmashhad_login.png';
        break;
  
      case "5fc9ee54-4f73-44f9-a452-7c6ff02231d1":
  
        labLogoPath = './LabIcons/lablogo_bahartehran_login.png';
        break;
  
      case "e311c5ed-0c24-43b1-a92f-ad137d816168":
  
        labLogoPath = './LabIcons/lablogo_boghrattehran_login.png';
        break;
  
      case "bae041bd-802c-4253-8ce2-3a77fd6bdc66":
  
        labLogoPath = './LabIcons/lablogo_danesh1tabriz_login.png';
        break;
  
      case "2f4d21a0-dc7b-44fa-9d18-8a643f1b18ad":
  
        labLogoPath = './LabIcons/lablogo_danesh2tabriz_login.png';
        break;
  
      case "be2e147b-da03-41da-9246-b07dcc44d52d":
  
        labLogoPath = './LabIcons/lablogo_denayasouj_login.png';
        break;
  
      case "083091d5-a7f1-400b-aac7-4e3e3b31c12a":
  
        labLogoPath = './LabIcons/lablogo_drdaneshbodshiraz_login.png';
        break;
  
      case "e5c75201-ef48-4b53-a3e8-edaee63ef4ca":
  
        labLogoPath = './LabIcons/lablogo_drmoaiedmashhad_login.png';
        break;
  
      case "4695e472-6390-4b9c-a4e9-1c02e686e7ad":
  
        labLogoPath = './LabIcons/lablogo_drmosavibandarabas_login.png';
        break;
  
      case "0e7442a7-4e16-464b-be4d-0d4e4772983b":
  
        labLogoPath = './LabIcons/lablogo_drshariatijiroft_login.png';
        break;
  
      case "46aff0d8-5fb7-499b-a3a0-401ba0dbab2b":
  
        labLogoPath = './LabIcons/lablogo_drtorabizadehdarab_login.png';
        break;
  
      case "654cbbfe-61db-4fef-bd76-daf0046c9172":
  
        labLogoPath = './LabIcons/lablogo_erythronesfehan_login.png';
        break;
  
      case "cce1cd5d-6aeb-45be-9d64-492c54b01ddf":
  
        labLogoPath = './LabIcons/lablogo_jahadmarkazimashahd_login.png';
        break;
  
      case "bfc2e43c-3aa8-4120-bac0-27017b26beee":
  
        labLogoPath = './LabIcons/lablogo_medicaltehran_login.png';
        break;
  
      case "ae6e4dce-d8e2-4d08-ada5-7bde555d591d":
  
        labLogoPath = './LabIcons/lablogo_miladesfehan_login.png';
        break;
  
      case "2fdc55b5-24e5-4e0d-83d6-a8312c9b815b":
  
        labLogoPath = './LabIcons/lablogo_niloutehran_login.png';
        break;
  
      case "85f2b221-4e9a-412c-87dc-4ba62ddc1f63":
  
        labLogoPath = './LabIcons/lablogo_oxygenshiraz_login.png';
        break;
  
      case "846c6a40-979d-4c47-ac7d-53db28488590":
  
        labLogoPath = './LabIcons/lablogo_pardismashhad_login.png';
        break;
  
      case "f06268e6-cb74-4a60-8224-5fbffe723fc7":
  
        labLogoPath = './LabIcons/lablogo_parsehtehran_login.png';
        break;
  
      case "9eab50fd-0b7b-46d4-b5ae-74d234a1e0ac":
  
        labLogoPath = './LabIcons/lablogo_pasteurkaraj_login.png';
        break;
  
      case "991ba4d0-f5ce-42e1-b0a8-590462a343bb":
  
        labLogoPath = './LabIcons/lablogo_pasteuryasoj_login.png';
        break;
  
      case "30e46b8d-11ec-4e7f-841e-f46eecf14467":
  
        labLogoPath = './LabIcons/lablogo_pathobiologymashhad_login.png';
        break;
  
      case "62e45f3d-b3a9-49b4-81db-c7971f8693ff":
  
        labLogoPath = './LabIcons/lablogo_peyvandshiraz_login.png';
        break;
  
      case "950799de-e703-442e-9e54-dd0fe5a35231":
  
        labLogoPath = './LabIcons/lablogo_peyvandtehran_login.png';
        break;
  
      case "eb51d9d2-945b-4d19-92ba-83e0cbd54af8":
  
        labLogoPath = './LabIcons/lablogo_pishrogazvin_login.png';
        break;
  
      case "67eff429-c26f-47d1-8663-a0a94e2e8a86":
  
        labLogoPath = './LabIcons/lablogo_sinarasht_login.png';
        break;
  
      case "6ee5644c-ef8f-4dcc-a192-5cbdb5f3c99b":
  
        labLogoPath = './LabIcons/lablogo_sinatehran_login.png';
        break;
  
      case "b596d2ac-0c50-4922-ad4f-3b8848a3b192":
  
        labLogoPath = './LabIcons/lablogo_vahdatkaraj_login.png';
        break;
  
      case "69d6c891-2558-4596-83d6-32815253ca23":
  
        labLogoPath = './LabIcons/lablogo_abantabriz_login.png';
        break;
  
      case "0ecbf298-bc89-4892-b0ad-5042cc3ca29a":
 
        labLogoPath = './LabIcons/lablogo_aftabtabriz_login.png';
        break;
  
      case "201eda44-a4f5-4a68-869c-d8eca7e25172":
  
        labLogoPath = './LabIcons/lablogo_madarkerman_login.png';
        break;
  
      case "513854f6-03fd-4cb0-8d5a-edac4fb4258c":
  
        labLogoPath = './LabIcons/lablogo_drrahnama_login.png';
        break;
  
      case "78eb1291-6150-45c5-8fe7-33a8204e383a":
  
        labLogoPath = './LabIcons/lablogo_hasanzadehbehshahr_login.png';
        break;
  
      case "135854f6-03fd-4cb0-8d5a-edac4fb4258c":
  
        labLogoPath = './LabIcons/lablogo_norozpormashhad_login.png';
        break;
  
      case "e50d7eb1-ce3a-4b5a-9bf0-61f4330d7676":
  
        labLogoPath = './LabIcons/lablogo_hosseininasabsanandaj_login.png';
        break;
  
      case "59d6c891-2558-4596-83d6-32815253ca23":
  
        labLogoPath = './LabIcons/lablogo_hakimtabriz_login.png';
        break;
  
      case "0c32894c-cbdc-41aa-8515-f0845ff98db4":
  
        labLogoPath = './LabIcons/lablogo_dryazdanpanah_login.png';
        break;
  
      case "90c48c76-b849-41c2-801c-f29ecfd7de17":
  
        labLogoPath = './LabIcons/lablogo_markazishahrrey_login.png';
        break;
  
      case "2775f6a5-978b-44e3-bc6a-e8b15b3d72db":
  
        labLogoPath = './LabIcons/lablogo_mehrdehdasht_login.png';
        break;
  
      case "d02cd611-9750-422d-90e0-07b3de908153":
  
        labLogoPath = './LabIcons/lablogo_mellatrasht_login.png';
        break;
  
      case "a952f5a1-dd1f-4cf5-bc91-4bf498d2a306":
  
        labLogoPath = './LabIcons/lablogo_parsianmashhad_login.png';
        break;
  
      case "35d3b9f0-5d18-4117-b7b0-a200ac0d52ef":
  
        labLogoPath = './LabIcons/lablogo_pasteurkhoy_login.png';
        break;
  
      case "6b9f3b45-613b-4ab4-b5c5-96560d23c60a":
  
        labLogoPath = './LabIcons/lablogo_pasteourmianeh_login.png';
        break;
  
      case "12fe2905-8ed1-4513-8c93-33d4658ad488":
  
        labLogoPath = './LabIcons/lablogo_raziqazvin_login.png';
        break;
  
      case "40e42ce3-0bd9-4073-a1d5-34dda424f1f5":
  
        labLogoPath = './LabIcons/lablogo_razibafgh_login.png';
        break;
  
      case "380ff463-dfe6-47ef-acb7-80c7f6128109":
  
        labLogoPath = './LabIcons/lablogo_sinamianeh_login.png';
        break;
  
      case "1116d5a7-af55-4b79-ae1c-d4d7a1edac33":
  
        labLogoPath = './LabIcons/lablogo_resalattehran_login.png';
        break;
  
      case "e3995886-eb3e-4c73-b890-d9313db1bd68":
  
        labLogoPath = './LabIcons/lablogo_hakimkaraj_login.png';
        break;
  
      case "eaffa040-a093-47dc-9efa-03cb8309ab57":
  
        labLogoPath = './LabIcons/lablogo_kosarkaraj_login.png';
        break;
  
      case "16a04998-8f16-420b-b6b4-43499871d5a9":
  
        labLogoPath = './LabIcons/lablogo_abrishami_login.png';
        break;
  
      case "053ce6a3-97e6-4276-b942-c182bdda2dc0":
  
        labLogoPath = './LabIcons/lablogo_abvabarghahvaz_login.png';
        break;
  
      case "6cc153e0-676e-4653-b856-75c1b9f32062":
  
        labLogoPath = './LabIcons/lablogo_afrarasht_login.png';
        break;
  
      case "ac199860-62e0-4e3f-99cc-7452c5a00baf":
  
        labLogoPath = './LabIcons/lablogo_alzahrakhomeyni_login.png';
        break;
  
      case "cbf111bd-1582-4c1b-af7e-3704a11ad444":
  
        labLogoPath = './LabIcons/lablogo_analizmaraghe_login.png';
        break;
  
      case "90dd656d-c663-450a-9a81-697506b988cc":
  
        labLogoPath = './LabIcons/lablogo_armaghantehran_login.png';
        break;
  
      case "b9afa8c0-cf0d-4693-baac-b30e553b97e7":
  
        labLogoPath = './LabIcons/lablogo_danarasht_login.png';
        break;
  
      case "e0eb3f01-d896-4d02-9132-9db76373502e":
  
        labLogoPath = './LabIcons/lablogo_daneshardebil_login.png';
        break;
  
      case "12ffd7f2-3131-446d-95e8-be85617b841f":
  
        labLogoPath = './LabIcons/lablogo_daneshmandarak_login.png';
        break;
  
      case "52188451-ed58-4dbc-b17f-37f0facccce6":
  
        labLogoPath = './LabIcons/lablogo_daneshneyshaboor_login.png';
        break;
  
      case "e4e292cb-c22a-4b0b-a00a-3dc0640d3c2d":
  
        labLogoPath = './LabIcons/lablogo_daneshsaghez_login.png';
        break;
  
      case "c606e7b9-43c1-4d05-853d-74ad8c79e47a":
  
        labLogoPath = './LabIcons/lablogo_deylahijan_login.png';
        break;
  
      case "bfa15abc-c2d7-497f-8347-007e9ecf17bf":
  
        labLogoPath = './LabIcons/lablogo_emamiemashhad_login.png';
        break;
  
      case "2125d5a7-af55-4b79-ae1c-d4d7a1edac33":
  
        labLogoPath = './LabIcons/lablogo_emamrezakashmar_login.png';
        break;
  
      case "6b79a472-40de-4e4a-b4eb-02472a87c842":
  
        labLogoPath = './LabIcons/lablogo_farhangianhashtgerd_login.png';
        break;
  
      case "295baeee-e776-4cda-ba90-3bcba861e5bf":
  
        labLogoPath = './LabIcons/lablogo_ghahremanzade_login.png';
        break;
  
      case "33cb8802-3296-42d7-8cbd-433e16ad048e":
  
        labLogoPath = './LabIcons/lablogo_ghavamoromie_login.png';
        break;
  
      case "a21295bc-4061-4f25-a1d3-c04d228e0ce9":
  
        labLogoPath = './LabIcons/lablogo_golshahrbandarabbas_login.png';
        break;
  
      case "0e0e2eb1-4c3a-462f-aee4-36434c7b677d":
  
        labLogoPath = './LabIcons/lablogo_hakimzarandie_login.png';
        break;
  
      case "9691db6f-b65a-4719-be0e-d55e3276caac":
  
        labLogoPath = './LabIcons/lablogo_hazratigorgan_login.png';
        break;
  
      case "c17753f1-c4fe-4ad7-a962-ee9cfe4b20b9":
  
        labLogoPath = './LabIcons/lablogo_hesarakkaraj_login.png';
        break;
  
      case "f2582fea-f50e-4260-b894-32df8089b0dd":
  
        labLogoPath = './LabIcons/lablogo_iranarak_login.png';
        break;
  
      case "6e40ab7d-f2f0-473b-b190-85d6a6ed7f7a":
  
        labLogoPath = './LabIcons/lablogo_jahaddaneshgahigonabad_login.png';
        break;
  
      case "19b30b42-8697-4b37-bcf2-4f3e191bff97":
  
        labLogoPath = './LabIcons/lablogo_jahaddaneshgahineyshaboor_login.png';
        break;
  
      case "17597c8f-d95d-4013-8cf2-b5f8237b5456":
  
        labLogoPath = './LabIcons/lablogo_jahan_login.png';
        break;
  
      case "85d40ec9-0e42-4067-b46c-adf0522283ce":
  
        labLogoPath = './LabIcons/lablogo_jarahbashi_login.png';
        break;
  
      case "6226c891-2558-4596-83d6-32815253ca23":
  
        labLogoPath = './LabIcons/lablogo_javanetehran_login.png';
        break;
  
      case "43963784-8214-48ef-a566-4136dabf816e":
  
        labLogoPath = './LabIcons/lablogo_jeyesfehan_login.png';
        break;
  
      case "c5c0eec4-bd47-498d-aed8-3eed48a8af1d":
  
        labLogoPath = './LabIcons/lablogo_kabirhamedan_login.png';
        break;
  
      case "94330c74-8436-416c-9b0b-57896cfc1760":
  
        labLogoPath = './LabIcons/lablogo_karbasi_login.png';
        break;
  
      case "5d704148-6600-42cf-9d92-07af9c79e52a":
  
        labLogoPath = './LabIcons/lablogo_kasrayazd_login.png';
        break;
  
      case "61d6c891-2558-4596-83d6-32815253ca23":
  
        labLogoPath = './LabIcons/lablogo_kavoushgorgan_login.png';
        break;
  
      case "40bcb168-17b4-49b6-aa5e-71e2d88e99a8":
  
        labLogoPath = './LabIcons/lablogo_kiacharpare_login.png';
        break;
  
      case "3494f176-f198-4810-931f-950d3bbf99a4":
  
        labLogoPath = './LabIcons/lablogo_kimiamashhad_login.png';
        break;
  
      case "45525b9b-2e14-42db-b394-46bcb4d1362f":
  
        labLogoPath = './LabIcons/lablogo_mad_login.png';
        break;
  
      case "1bcdcafe-33f3-41a2-9c42-af5e4a5d67de":
  
        labLogoPath = './LabIcons/lablogo_medikatabriz_login.png';
        break;
  
      case "7f72b7b1-55a7-4910-a5d7-d955b667ff9f":
  
        labLogoPath = './LabIcons/lablogo_mehranazimie_login.png';
        break;
  
      case "a7830334-985e-41bd-be40-2177684c3e25":
  
        labLogoPath = './LabIcons/lablogo_mehrastane_login.png';
        break;
  
      case "be6d83bb-263e-45fc-8905-75e0e1f4c872":
  
        labLogoPath = './LabIcons/lablogo_mehrkhoy_login.png';
        break;
  
      case "37c53dd0-fb84-4832-b118-aeae5a5538a6":
  
        labLogoPath = './LabIcons/lablogo_mehrnaghade_login.png';
        break;
  
      case "8ca8f99d-8a21-4a43-884e-a2022559d6d0":
  
        labLogoPath = './LabIcons/lablogo_mehrrasht_login.png';
        break;
  
      case "e837c10c-f9c6-462e-9dc1-4cb5318241a9":
  
        labLogoPath = './LabIcons/lablogo_miladsanandaj_login.png';
        break;
  
      case "d7bc8675-9029-40a3-9193-717c53c6c9a8":
  
        labLogoPath = './LabIcons/lablogo_miladzanjan_login.png';
        break;
  
      case "7cf65dc9-70bd-470b-a470-f8abb35b912b":
  
        labLogoPath = './LabIcons/lablogo_milladtehran_login.png';
        break;
  
      case "c86b60af-15b2-43c3-a05f-0744fd29915d":
  
        labLogoPath = './LabIcons/lablogo_modern_login.png';
        break;
  
      case "ba5e4282-53b6-4c05-a698-80bf6e79c98f":
  
        labLogoPath = './LabIcons/lablogo_moghimi_login.png';
        break;
  
      case "35e9c7fc-13b3-496f-b2e8-aa2e1cb55c77":
  
        labLogoPath = './LabIcons/lablogo_mohsen_login.png';
        break;
  
      case "ff1cd3ab-68fc-429d-a05a-67d846d85a9b":
  
        labLogoPath = './LabIcons/lablogo_monsefmashhad_login.png';
        break;
  
      case "5ca4f878-722e-407f-bd48-3f5ec7385be5":
  
        labLogoPath = './LabIcons/lablogo_nemoonetabriz_login.png';
        break;
  
      case "6d40ab7d-f2f0-473b-b190-85d6a6ed7f7a":
  
        labLogoPath = './LabIcons/lablogo_nikfarjam_login.png';
        break;
  
      case "f1c62ba2-f7d1-496d-8d74-94c934bab5d2":
  
        labLogoPath = './LabIcons/lablogo_nooredaneshyasooj_login.png';
        break;
  
      case "9587250a-0a91-4aca-96a2-aad114524d03":
  
        labLogoPath = './LabIcons/lablogo_noorsanandaj_login.png';
        break;
  
      case "38c7e0e3-d0ca-4359-8168-6469d38cd9c6":
  
        labLogoPath = './LabIcons/lablogo_noortabriz_login.png';
        break;
  
      case "70bce572-c759-4a66-8bde-a77c4c6e80ed":
  
        labLogoPath = './LabIcons/lablogo_nooryazd_login.png';
        break;
  
      case "c4cfb6bf-7229-4625-bc23-b6fa5673e21d":
  
        labLogoPath = './LabIcons/lablogo_omidvari_login.png';
        break;
  
      case "0b47d72d-b442-476f-a4de-43a660cc0b83":
  
        labLogoPath = './LabIcons/lablogo_ordibeheshttehran_login.png';
        break;
  
      case "5dd593e6-2fcb-49ba-b466-a0bd080524f5":
  
        labLogoPath = './LabIcons/lablogo_parschaloos_login.png';
        break;
  
      case "e6e98bff-5c48-41ff-9051-3ee68e2b8280":
  
        labLogoPath = './LabIcons/lablogo_parssave_login.png';
        break;
  
      case "a9c1d4b4-38d8-4973-9ab1-214510251153":
  
        labLogoPath = './LabIcons/lablogo_part_login.png';
        break;
  
      case "32f90e3f-8dde-4750-8450-c68c60a81d53":
  
        labLogoPath = './LabIcons/lablogo_pasargadahvaz_login.png';
        break;
  
      case "195beaaa-e776-4cda-ba90-3bcba861e5bf":
  
        labLogoPath = './LabIcons/lablogo_pasargadkaraj_login.png';
        break;
  
      case "c4584bb5-6d9a-405c-995b-dac5550d217f":
  
        labLogoPath = './LabIcons/lablogo_pastorsanandaj_login.png';
        break;
  
      case "52bb130e-a25b-4808-a1df-fceccc29ce1a":
  
        labLogoPath = './LabIcons/lablogo_pastorshazand_login.png';
        break;
  
      case "af481f5a-1e75-4686-b179-f2753ef6b100":
  
        labLogoPath = './LabIcons/lablogo_payamtandorosti_login.png';
        break;
  
      case "332435ac-85d6-4c06-81d1-bd7541b04818":
  
        labLogoPath = './LabIcons/lablogo_pishgaman_login.png';
        break;
  
      case "dc091ce1-518b-4b04-a1d8-1a9f39563d00":
  
        labLogoPath = './LabIcons/lablogo_pishgambirjand_login.png';
        break;
  
      case "8be5175e-fa78-452f-849a-509a54c1b978":
  
        labLogoPath = './LabIcons/lablogo_plasma_login.png';
        break;
  
      case "3236d5a7-af55-4b79-ae1c-d4d7a1edac33":
  
        labLogoPath = './LabIcons/lablogo_rasa_login.png';
        break;
  
      case "c5b1d9fa-1f8b-4f2e-98a1-ab735664f06d":
  
        labLogoPath = './LabIcons/lablogo_razashahrood_login.png';
        break;
  
      case "72d112a4-536b-409a-9057-2fef88f7ebe5":
  
        labLogoPath = './LabIcons/lablogo_razavilamerd_login.png';
        break;
  
      case "7818230f-631f-43b8-bbba-c19e808b1be1":
  
        labLogoPath = './LabIcons/lablogo_rosha_login.png';
        break;
  
      case "e77187e4-1913-4e61-8b1a-ec8a63b5f817":
  
        labLogoPath = './LabIcons/lablogo_saboorelam_login.png';
        break;
  
      case "16dc6e27-ffca-493a-a978-7167836737f2":
  
        labLogoPath = './LabIcons/lablogo_sadrachaypare_login.png';
        break;
  
      case "111cbaaa-e776-4cda-ba90-3bcba861e5bf":
  
        labLogoPath = './LabIcons/lablogo_sadramashhad_login.png';
        break;
  
      case "b43dc3e4-d5e0-4e13-b779-d287adeadb44":
  
        labLogoPath = './LabIcons/lablogo_sadrtabriz_login.png';
        break;
  
      case "743607f9-2c90-47be-bef9-78a08164ee83":
  
        labLogoPath = './LabIcons/lablogo_sajadshahrood_login.png';
        break;
  
      case "8f10fbcb-b4dc-4235-a9fc-98b1c2cfa862":
  
        labLogoPath = './LabIcons/lablogo_salamatshahrghods_login.png';
        break;
  
      case "23e7a4e4-23a6-47df-a4fb-8b9fad2b9ff5":
  
        labLogoPath = './LabIcons/lablogo_salamtabriz_login.png';
        break;
  
      case "635c891-2558-4596-83d6-32815253ca23":
  
        labLogoPath = './LabIcons/lablogo_saminbonab_login.png';
        break;
  
      case "aa640957-1e2a-4b07-ae27-b8b46111c81b":
  
        labLogoPath = './LabIcons/lablogo_sepidaliadad_login.png';
        break;
  
      case "b062a137-1ed9-43c3-8ac6-061ff5c78bdf":
  
        labLogoPath = './LabIcons/lablogo_sepidartehran_login.png';
        break;
  
      case "990ba19e-a51e-40f9-9476-e0410ee82942":
  
        labLogoPath = './LabIcons/lablogo_sepidsari_login.png';
        break;
  
      case "53a9fa20-0518-44ed-b4f5-f9041c56a7fe":
  
        labLogoPath = './LabIcons/lablogo_shafaneyshapour_login.png';
        break;
  
      case "824243c0-bac8-4a44-b764-7634a9cf557f":
  
        labLogoPath = './LabIcons/lablogo_shahrara_login.png';
        break;
  
      case "c2bbc8d4-1ab7-4cc4-8be5-255627fbe800":
  
        labLogoPath = './LabIcons/lablogo_shayegan_login.png';
        break;
  
      case "ecc1b348-30bd-442e-9a6a-1a6fe4b0eabe":
  
        labLogoPath = './LabIcons/lablogo_sinaarak_login.png';
        break;
  
      case "90acd8db-f2ed-43da-aaad-cac7e19e3421":
  
        labLogoPath = './LabIcons/lablogo_sinabehshahr_login.png';
        break;
  
      case "11ff3acb-4338-4586-acff-7b013264ec41":
  
        labLogoPath = './LabIcons/lablogo_tabanmashhad_login.png';
        break;
  
      case "f05a7a50-6b63-405f-a291-934f998abee5":
  
        labLogoPath = './LabIcons/lablogo_tollabmashhad_login.png';
        break;
  
      case "4689a470-700f-4945-9a9e-61ad25d64b51":
  
        labLogoPath = './LabIcons/lablogo_vatankhah_login.png';
        break;
  
      case "1fed9f7e-a432-4301-9777-3bec5bdf7d1c":
  
        labLogoPath = './LabIcons/lablogo_zafar_login.png';
        break;
  
      case "1cc58f7e-ba5f-4d16-9df0-ce0902f6446e":
  
        labLogoPath = './LabIcons/lablogo_zohrabi_login.png';
        break;
  
      case "ed595fab-54c8-4eff-a504-d5bedafe8d91":
  
        labLogoPath = './LabIcons/lablogo_adelzadeh_login.png';
        break;
  
      case "275778ac-f0fb-49e7-aab1-183987abf4f0":
  
        labLogoPath = './LabIcons/lablogo_aminkaraj_login.png';
        break;
  
      case "338dec9e-637c-47f2-a1a7-9a78ba7cfa9c":
  
        labLogoPath = './LabIcons/lablogo_analizeardebil_login.png';
        break;
  
      case "659c1ab7-b603-4464-8f87-a1252fe0a033":
  
        labLogoPath = './LabIcons/lablogo_analyzajabshir_login.png';
        break;
  
      case "1adf0e42-9998-4160-a58f-e587a9a12710":
  
        labLogoPath = './LabIcons/lablogo_atiyehrasht_login.png';
        break;
  
      case "391f4535-381e-40f0-ae8e-fc0772f17ab0":
  
        labLogoPath = './LabIcons/lablogo_baharestan_login.png';
        break;
  
      case "15d9fb21-45ca-4393-8613-3b1fffec05ff":
  
        labLogoPath = './LabIcons/lablogo_baharzanjan_login.png';
        break;
  
      case "917ac5cf-560f-4dc4-aa94-3001aed8e9cb":
  
        labLogoPath = './LabIcons/lablogo_bazrafshan_login.png';
        break;
  
      case "63dbed87-dd50-425d-a775-178169ce9ceb":
  
        labLogoPath = './LabIcons/lablogo_behnood_login.png';
        break;
  
      case "ad501d16-135d-4aa6-a495-bef9ff2b9b1e":
  
        labLogoPath = './LabIcons/lablogo_daneshkhoy_login.png';
        break;
  
      case "8663df77-ce64-48a4-830c-4a608bdf19ef":
  
        labLogoPath = './LabIcons/lablogo_daneshqom_login.png';
        break;
  
      case "f98d5e4e-9990-4b53-b3f6-faf1561bc7aa":
  
        labLogoPath = './LabIcons/lablogo_dehbozorgian_login.png';
        break;
  
      case "9965e0ff-cca8-431e-9fee-620b75be29da":
  
        labLogoPath = './LabIcons/lablogo_dralijani_login.png';
        break;
  
      case "dcc5cca0-0138-4b2e-a561-0173749ce96f":
  
        labLogoPath = './LabIcons/lablogo_dresmaeli_login.png';
        break;
  
      case "6f6d4626-3cc2-4823-a953-babfbc344bd7":
  
        labLogoPath = './LabIcons/lablogo_hakimibaneh_login.png';
        break;
  
      case "bd6c605e-ef15-431a-b86c-4984402f1e8e":
  
        labLogoPath = './LabIcons/lablogo_iranian_login.png';
        break;
  
      case "17935c47-e107-4591-b5d7-cbba2127437d":
  
        labLogoPath = './LabIcons/lablogo_jalali_login.png';
        break;
  
      case "43c640f6-5eff-4983-acc2-06c4ee10a790":
  
        labLogoPath = './LabIcons/lablogo_kaheh_login.png';
        break;
  
      case "29491da0-af8c-4466-ac19-39dad54e62e3":
  
        labLogoPath = './LabIcons/lablogo_khakpour_login.png';
        break;
  
      case "0a35db12-f099-4aa6-922c-5d3b0bc8a88e":
  
        labLogoPath = './LabIcons/lablogo_khorshidesfahan_login.png';
        break;
  
      case "2a863dde-91eb-44b0-a0b5-5d3ff310aa4d":
  
        labLogoPath = './LabIcons/lablogo_kianersi_login.png';
        break;
  
      case "147bb0f6-ba6b-4465-b6c2-804661b20f21":
  
        labLogoPath = './LabIcons/lablogo_kowsarkhomainyshahr_login.png';
        break;
  
      case "ca192716-6aa5-4926-90fe-93c54e989b7c":
  
        labLogoPath = './LabIcons/lablogo_lashkari_login.png';
        break;
  
      case "754434f5-6c78-4f3e-a199-370b873f0160":
  
        labLogoPath = './LabIcons/lablogo_markazjoghatay_login.png';
        break;
  
      case "05c47038-e198-4cff-a2fb-97d9c83ed744":
  
        labLogoPath = './LabIcons/lablogo_mehrkaraj_login.png';
        break;
  
      case "11bfed64-93aa-46bf-bf64-ca23ac2d0f6b":
  
        labLogoPath = './LabIcons/lablogo_miladtabriz_login.png';
        break;
  
      case "d57c17a4-88e0-4e75-a207-b653430edf47":
  
        labLogoPath = './LabIcons/lablogo_navid_login.png';
        break;
  
      case "a0f41206-1e4f-4f69-8a1b-5aeb9b057fd3":
  
        labLogoPath = './LabIcons/lablogo_neginvanak1_login.png';
        break;
  
      case "21ccad64-93aa-46bf-bf64-ca23ac2d0f6b":
  
        labLogoPath = './LabIcons/lablogo_nezhadeh_login.png';
        break;
  
      case "2df9f92c-41c7-491a-8576-307ecbf03cff":
  
        labLogoPath = './LabIcons/lablogo_nikoo_login.png';
        break;
  
      case "ce83e853-79e4-4ff9-8170-46940ef3776d":
  
        labLogoPath = './LabIcons/lablogo_noavaran_login.png';
        break;
  
      case "4a3b5505-760c-4959-ae9f-9b6b5bac76b7":
  
        labLogoPath = './LabIcons/lablogo_novinarak_login.png';
        break;
  
      case "ff841999-afc6-4351-b0f8-f2661bc4c5ab":
  
        labLogoPath = './LabIcons/lablogo_parsianesfahan_login.png';
        break;
  
      case "d946ebb3-baeb-4919-8288-330ed53a6e7e":
  
        labLogoPath = './LabIcons/lablogo_parsqom_login.png';
        break;
  
      case "9496ea3c-6165-4f68-89d4-cfc3eaf7fb5f":
  
        labLogoPath = './LabIcons/lablogo_parstabriz_login.png';
        break;
  
      case "0d835149-cc3f-4c34-b35c-1f1a6a0f8e29":
  
        labLogoPath = './LabIcons/lablogo_parszhenom_login.png';
        break;
  
      case "3cbbf766-0198-40c3-aa22-26d7608631b7":
  
        labLogoPath = './LabIcons/lablogo_pasargadahar_login.png';
        break;
  
      case "2468c9e1-c878-4c15-a01e-24e3ee80cf5a":
  
        labLogoPath = './LabIcons/lablogo_razimianeh_login.png';
        break;
  
      case "643a22ad-aa2c-45e8-9070-8de62418f836":
  
        labLogoPath = './LabIcons/lablogo_saee_login.png';
        break;
  
      case "6f99e248-fd14-4d91-8072-87abb7fa8037":
  
        labLogoPath = './LabIcons/lablogo_sajjadghazvin_login.png';
        break;
  
      case "92d7211b-a776-4cb5-b5bc-3a3aafc33744":
  
        labLogoPath = './LabIcons/lablogo_sinazarinshahr_login.png';
        break;
  
      case "47309901-468c-4814-91ee-286e37c004a7":
  
        labLogoPath = './LabIcons/lablogo_tahghigh_login.png';
        break;
  
      case "f82efc1e-c465-4100-9c21-91146c7ff6e8":
  
        labLogoPath = './LabIcons/lablogo_virchow_login.png';
        break;
  
      case "60300911-087f-4b04-9bb4-2f83de8f941a":
  
        labLogoPath = './LabIcons/lablogo_yasuj_login.png';
        break;
  
      case "4ae449a2-a8d9-431e-867b-9eba248fd165":
  
        labLogoPath = './LabIcons/lablogo_aminghom_login.png';
        break;
  
      case "454b6eae-d197-4008-90f0-8ecb5934a79e":
  
        labLogoPath = './LabIcons/lablogo_ariakaraj_login.png';
        break;
  
      case "1de7c36e-6749-4869-aaee-2f79cee04717":
  
        labLogoPath = './LabIcons/lablogo_farhangiankaraj_login.png';
        break;
  
      case "7043a8f4-ea40-45c5-a820-8a17dba1970b":
  
        labLogoPath = './LabIcons/lablogo_kashefkaraj_login.png';
        break;
  
      case "7e40ab7d-f2f0-473b-b190-85d6a6ed7f7a":
  
        labLogoPath = './LabIcons/lablogo_markazifardis_login.png';
        break;
  
      case "c44b678e-8ac1-4691-80ed-23b7e993e024":
  
        labLogoPath = './LabIcons/lablogo_parsdarman_login.png';
        break;
  
      case "6f914d7a-ae9c-430d-b825-1d29d0060d42":
  
        labLogoPath = './LabIcons/lablogo_absharmashhad_login.png';
        break;
  
      case "fbbe767f-3d68-425f-9314-8c8e74877360":
  
        labLogoPath = './LabIcons/lablogo_arg_login.png';
        break;
  
      case "dc6a2adb-649a-43fe-bc56-29fe0f7e3eca":
  
        labLogoPath = './LabIcons/lablogo_arsalanmashhad_login.png';
        break;
  
      case "4fbccbda-f610-414c-942b-026e0daa4062":
  
        labLogoPath = './LabIcons/lablogo_ashabalhosein_login.png';
        break;
  
      case "76ba84c8-a0a9-4ac8-bbf2-889944cd9bfd":
  
        labLogoPath = './LabIcons/lablogo_royeshsabzevar_login.png';
        break;
        
      case "54a86485-3855-4ff2-ac18-d71b6c950a6a":
  
        labLogoPath = './LabIcons/lablogo_azadimeimeh_login.png';
        break;
  
      case "e2cf360b-b3e1-4754-a1df-8a357cee82f6":
  
        labLogoPath = './LabIcons/lablogo_basir_login.png';
        break;
  
      case "946cf497-95e9-4448-a083-e461fcf45ef7":
  
        labLogoPath = './LabIcons/lablogo_bonyanorumieh_login.png';
        break;
  
      case "07637f56-7e0f-4e73-8be4-5e5fabb524d1":
  
        labLogoPath = './LabIcons/lablogo_bualikhomeinishahr_login.png';
        break;
  
      case "3cbfa16d-66f3-4841-b1ae-8e9aeea8ee4b":
  
        labLogoPath = './LabIcons/lablogo_daneshfasa_login.png';
        break;
  
      case "1338044f-257f-4da5-a222-3c7c8ff06e12":
  
        labLogoPath = './LabIcons/lablogo_daneshmianeh_login.png';
        break;
  
      case "2d392c60-8675-4469-99e4-eb387e752392":
  
        labLogoPath = './LabIcons/lablogo_deyesfahan_login.png';
        break;
  
      case "1418d107-5b93-4082-b1b0-4333c6914e79":
  
        labLogoPath = './LabIcons/lablogo_dralizadehshahriar_login.png';
        break;
  
      case "a93b9b2e-d350-4fbb-ab52-ee0509f6bf2e":
  
        labLogoPath = './LabIcons/lablogo_dramirabi_login.png';
        break;
  
      case "ad9fb477-216f-4ec2-ab19-0891bea3a520":
  
        labLogoPath = './LabIcons/lablogo_drarami_login.png';
        break;
  
      case "7305e6c6-466c-4b65-a4a6-211d5b9947f6":
  
        labLogoPath = './LabIcons/lablogo_drdabiri_login.png';
        break;
  
      case "588ad396-3ffc-4bb9-a7eb-1064274ad19c":
  
        labLogoPath = './LabIcons/lablogo_drejtehadi_login.png';
        break;
  
      case "4c7b2004-8984-4168-aaab-293d33eeb260":
  
        labLogoPath = './LabIcons/lablogo_drfuladi_login.png';
        break;
  
      case "e97b3b61-c509-41ef-bcee-a0a1b00900a9":
  
        labLogoPath = './LabIcons/lablogo_drhasaniborujerd_login.png';
        break;
  
      case "00218d49-3d39-4114-891e-2133a2154edd":
  
        labLogoPath = './LabIcons/lablogo_drhedayatniamashhad_login.png';
        break;
  
      case "3690e1dd-b1fe-4c15-8435-5c81762dd952":
  
        labLogoPath = './LabIcons/lablogo_drkhorshid_login.png';
        break;
  
      case "3e2243a2-9aa4-4251-a5e2-14f0deb47fab":
  
        labLogoPath = './LabIcons/lablogo_drradmanesh_login.png';
        break;
  
      case "bc5f803c-cb68-4a4f-9a12-8aa9701683a7":
  
        labLogoPath = './LabIcons/lablogo_drsalimi_login.png';
        break;
  
      case "63b4425c-3b66-48ee-a9c4-3df9f9dde61f":
  
        labLogoPath = './LabIcons/lablogo_drshafazandkerman_login.png';
        break;
  
      case "e2e8babc-1c6a-4e88-8e04-b667ae625814":
  
        labLogoPath = './LabIcons/lablogo_emamkhomeinidezful_login.png';
        break;
  
      case "bc962441-ec7a-48d4-922c-fea79ba02b63":
  
        labLogoPath = './LabIcons/lablogo_eritron_login.png';
        break;
  
      case "62f68fe6-0754-4c06-a5c0-f47c86e44128":
  
        labLogoPath = './LabIcons/lablogo_farhangiantehran_login.png';
        break;
  
      case "e636b9be-f3c8-4815-ae6c-5cebb90f67be":
  
        labLogoPath = './LabIcons/lablogo_faz1marlik_login.png';
        break;
  
      case "940c3abc-ce9f-445a-a884-3bcecd481ff9":
  
        labLogoPath = './LabIcons/lablogo_ferdosmashhad_login.png';
        break;
  
      case "5013280e-27f2-4665-8cc6-d2ceac0f7b66":
  
        labLogoPath = './LabIcons/lablogo_hakimaligudarz_login.png';
        break;
  
      case "3e443219-9cfb-4d47-9842-5484481b833b":
  
        labLogoPath = './LabIcons/lablogo_hormon_login.png';
        break;
  
      case "5ac67e83-def3-4ff4-b4fd-be83a198d97d":
  
        labLogoPath = './LabIcons/lablogo_jam_login.png';
        break;
  
      case "04f5ac34-5224-49fb-b210-18ab6fdc250d":
  
        labLogoPath = './LabIcons/lablogo_jamejamesfahan_login.png';
        break;
  
      case "4da7a742-4a10-4ca2-b626-e06314fd9206":
  
        labLogoPath = './LabIcons/lablogo_kasheffalavarjan_login.png';
        break;
  
      case "441e8c7d-ada8-4f74-a1df-c968bce3a913":
  
        labLogoPath = './LabIcons/lablogo_kasraesfahan_login.png';
        break;
  
      case "dcd0f604-eec7-415e-a742-635fc6ddffa2":
  
        labLogoPath = './LabIcons/lablogo_kurosh_login.png';
        break;
  
      case "038504cc-26c4-4320-9724-7c411422cbad":
  
        labLogoPath = './LabIcons/lablogo_mahan_login.png';
        break;
  
      case "178c5b48-50f8-4eb0-b1f1-755032cffc4c":
  
        labLogoPath = './LabIcons/lablogo_mahtab_login.png';
        break;
  
      case "ce667391-4213-4479-965e-21a863f42752":
  
        labLogoPath = './LabIcons/lablogo_maisa_login.png';
        break;
  
      case "90d038c4-b61e-4ffc-9962-931e23350592":
  
        labLogoPath = './LabIcons/lablogo_mazda_login.png';
        break;
  
      case "f58c7b94-84f1-4f77-badb-1e3dea43014b":
  
        labLogoPath = './LabIcons/lablogo_mehrborujerd_login.png';
        break;
  
      case "ec9130c9-4315-4d41-a8ab-ff0a176f87dc":
  
        labLogoPath = './LabIcons/lablogo_mehrpiranshahr_login.png';
        break;
  
      case "75dd26d1-e2fb-4a0a-8a4d-41166aa9e05b":
        labLogoPath = './LabIcons/lablogo_ahmadibehshahr_login.png';
        break;
  
      case "d4aeb483-3ea5-4877-9876-2124dfddb6b5":
  
        labLogoPath = './LabIcons/lablogo_almahdishahrekord_login.png';
        break;
  
      case "24d6f5fa-7918-4857-9b65-2f29923f7805":
  
        labLogoPath = './LabIcons/lablogo_azarabadegan_login.png';
        break;
  
      case "eb0c51be-70d2-4e9c-8879-72a5f542eea2":
  
        labLogoPath = './LabIcons/lablogo_bualiasadabad_login.png';
        break;
  
      case "ce7bd1a3-0d0b-4b35-91a3-ee721449588a":
  
        labLogoPath = './LabIcons/lablogo_drgharib_login.png';
        break;
  
      case "a5733358-6a6f-4e20-9855-4e1f18677778":
  
        labLogoPath = './LabIcons/lablogo_farabiarak_login.png';
        break;
  
      case "84e17db8-5e5c-4822-b9cb-54a429439323":
  
        labLogoPath = './LabIcons/lablogo_farzanegan_login.png';
        break;
  
      case "b28aa49c-2dc0-4cff-a3d8-bca1a07aaf91":
  
        labLogoPath = './LabIcons/lablogo_genazma_login.png';
        break;
  
      case "c5cc3a84-238a-4eac-9c31-8cfc7fcde7da":
  
        labLogoPath = './LabIcons/lablogo_genum_login.png';
        break;
  
      case "09a0b289-b4ae-4704-b8b6-aa06a9892e5b":
  
        labLogoPath = './LabIcons/lablogo_genumorumieh_login.png';
        break;
  
      case "2c9a68f6-702d-4fa7-8bba-2a75144d25e6":
  
        labLogoPath = './LabIcons/lablogo_kosarmashhad_login.png';
        break;
  
      case "d25e9f08-14fe-4930-8aa5-ec88d3b48e89":
  
        labLogoPath = './LabIcons/lablogo_landagorgan_login.png';
        break;
  
      case "7a512207-b6bc-4b60-9a57-2d49ae819371":
  
        labLogoPath = './LabIcons/lablogo_landatabriz_login.png';
        break;
  
      case "56af5d93-08f3-4765-82fe-3cb569c6eba3":
  
        labLogoPath = './LabIcons/lablogo_mehrvaramin_login.png';
        break;
  
      case "1f786095-f94b-4ae2-a111-1b7369e39739":
  
        labLogoPath = './LabIcons/lablogo_mendel_login.png';
        break;
  
      case "04a5a305-ac9a-47fe-9b71-960bc1fbb564":
  
        labLogoPath = './LabIcons/lablogo_nik_login.png';
        break;
  
      case "7dedfb36-0f68-48d3-8a73-a2912e8468d3":
  
        labLogoPath = './LabIcons/lablogo_nikan_login.png';
        break;
  
      case "879cfdfb-231f-472f-ac42-2c80df526f5e":
  
        labLogoPath = './LabIcons/lablogo_nilourasht_login.png';
        break;
  
      case "48f285fc-3c3f-4c16-af0c-a72c7b43c27e":
  
        labLogoPath = './LabIcons/lablogo_noorjiroft_login.png';
        break;
  
      case "28ad7502-63b5-4bf0-94ef-1f98e621b7a0":
  
        labLogoPath = './LabIcons/lablogo_norogen_login.png';
        break;
  
      case "67718298-9fef-4e58-97cd-21338a0a3e0a":
  
        labLogoPath = './LabIcons/lablogo_novinghom_login.png';
        break;
  
      case "8bf106c4-78a4-436b-96fe-0727d2f8570a":
  
        labLogoPath = './LabIcons/lablogo_novinpakdasht_login.png';
        break;
  
      case "8bc88bc4-deef-4988-9b7e-970ae605c441":
  
        labLogoPath = './LabIcons/lablogo_pardisdorud_login.png';
        break;
  
      case "74bafcbd-8f3d-40f6-b52a-838974542850":
  
        labLogoPath = './LabIcons/lablogo_pargen_login.png';
        break;
  
      case "c807b073-2587-4cb0-9d9f-a9ca06a4208c":
  
        labLogoPath = './LabIcons/lablogo_parsianmahshahr_login.png';
        break;
  
      case "737526b0-f193-4bc8-b75c-aa8b450f0be6":
  
        labLogoPath = './LabIcons/lablogo_pasteurtonekabon_login.png';
        break;
  
      case "a141275c-07d8-4ae6-bd0f-d4f6170f5de7":
  
        labLogoPath = './LabIcons/lablogo_pastorbabool_login.png';
        break;
  
      case "37ef2c9e-6617-4aad-9437-fab527bac28d":
  
        labLogoPath = './LabIcons/lablogo_pastorzarinshahr_login.png';
        break;
  
      case "2a5a81a7-102c-4cd5-a177-32f22dd5a03b":
  
        labLogoPath = './LabIcons/lablogo_payammashhad_login.png';
        break;
  
      case "5546410e-3339-4aa0-b53d-e30c23a6df2c":
  
        labLogoPath = './LabIcons/lablogo_plasmatabriz_login.png';
        break;
  
      case "f77bb50c-77cd-4944-922c-71650bfc71d6":
  
        labLogoPath = './LabIcons/lablogo_pursinaabhar_login.png';
        break;
  
      case "6ba4f878-722e-407f-bd48-3f5ec7385be5":
  
        labLogoPath = './LabIcons/lablogo_raziabadan_login.png';
        break;
  
      case "27c2fa63-7991-4624-83cc-1a8a945a2358":
  
        labLogoPath = './LabIcons/lablogo_razikerman_login.png';
        break;
  
      case "f830427c-6921-4288-8fa5-9d95210e4129":
  
        labLogoPath = './LabIcons/lablogo_razirafsanjan_login.png';
        break;
  
      case "cee2e27e-1f38-4fe7-8bd6-b6d9048e68d7":
  
        labLogoPath = './LabIcons/lablogo_sabzshahr_login.png';
        break;
  
      case "eeb26a70-31e7-4b60-9ac3-83e290bd07fb":
  
        labLogoPath = './LabIcons/lablogo_sadraghom_login.png';
        break;
  
      case "455f6e44-22ce-4741-a078-3b8f6b453dcf":
  
        labLogoPath = './LabIcons/lablogo_salamatsari_login.png';
        break;
  
      case "9a01cde4-69cd-4d8b-8f70-d1402cde2721":
  
        labLogoPath = './LabIcons/lablogo_samanmashhad_login.png';
        break;
  
      case "5e31a3ca-cd86-4c6f-8613-8ae4327a3e7e":
  
        labLogoPath = './LabIcons/lablogo_samenalaemmehfarsan_login.png';
        break;
  
      case "087f9e60-76a6-4726-a4dc-0992a2ca7791":
  
        labLogoPath = './LabIcons/lablogo_sepehrgorgan_login.png';
        break;
  
      case "d43e79c6-0836-49c5-8c8b-8a2ca413e105":
  
        labLogoPath = './LabIcons/lablogo_shafanaeen_login.png';
        break;
  
      case "ac194d40-c0aa-476c-8d04-a9ab3dc49a90":
  
        labLogoPath = './LabIcons/lablogo_shafazandsirjan_login.png';
        break;
  
      case "349d33ca-7093-4633-8eb6-927466c50856":
  
        labLogoPath = './LabIcons/lablogo_sinatabriz_login.png';
        break;
  
      case "8830467a-39be-4259-b14a-630391eeb79d":
  
        labLogoPath = './LabIcons/lablogo_sorushesfahan_login.png';
        break;
  
      case "e0a180cb-9103-462e-8b30-12331523705a":
  
        labLogoPath = './LabIcons/lablogo_vahidesfahan_login.png';
        break;
  
      case "5d414678-75a8-4ce9-a96d-98e17bac95d9":
  
        labLogoPath = './LabIcons/lablogo_vahidzarinshahr_login.png';
        break;
  
      case "1f0222f5-c48a-4460-a329-2643fdc876f2":
  
        labLogoPath = './LabIcons/lablogo_valiasrazarshahr_login.png';
        break;
  
      case "8fb6edc3-b2d8-48f2-ba03-b237b0135e93":
  
        labLogoPath = './LabIcons/lablogo_valiasrkhoy_login.png';
        break;
  
      case "d905c6de-3d22-4b38-b7c1-98c43aedca95":
  
        labLogoPath = './LabIcons/lablogo_varianshahr_login.png';
        break;
  
      case "89970378-e6af-483b-bbd5-905e4f8a927f":
  
        labLogoPath = './LabIcons/lablogo_yasflowercity_login.png';
        break;
  
      case "a33d52e5-fb80-423c-8acc-5781dcf29fb5": case "fa380cfc-0514-4902-be27-5883f720fde6": case "093c1bd8-967f-4d62-9b17-cc6e14e830b5": case "815a5c89-e563-46e4-b907-d37568f7d11b": case "dc4c612c-6c2a-48c3-b3f5-a3f629a18b0e":
  
        labLogoPath = './LabIcons/lablogo_naftesfahandarvazehtehran_login.png';
        break;

      case "3dbab2de-c58d-46c8-b7e9-852744ebb09e":
  
          labLogoPath = './LabIcons/lablogo_mellalisfehan_login.png';
        break;
  
      case "e4e292cb-c22a-4b0b-a00a-3dc0640d3c2d" :
        labLogoPath = './LabIcons/lablogo_daneshsaghez_login.png';
        break;

      case "c7fef61f-e7be-4a74-84aa-bb880b888b6e" :
        labLogoPath = './LabIcons/lablogo_daneshmarivan_login.png';
        break;

      case "635c891-2558-4596-83d6-32815253ca23" :
        labLogoPath = './LabIcons/lablogo_saminbonab_login.png';
        break;

      case "0eb208f6-72f6-4f5c-9bb3-632d8847b547" :
        labLogoPath = './LabIcons/lablogo_mahsatehran_login.png';
        break;

      case "f263be3f-a6bd-453c-9368-9c1b54175d40" :
        labLogoPath = './LabIcons/lablogo_mehrhashgerd_login.png';
        break;
  
      case "d7c2e597-8432-45b1-8e33-9a0d5e2114fa" :
        labLogoPath = './LabIcons/lablogo_mehrtabriz_login.png';
        break;

      case "8f32793b-cc1f-4db3-9b99-5cc411c20c4a" :
        labLogoPath = './LabIcons/lablogo_drmaleknasab_login.png';
        break;
  
      case "dca63867-6756-441b-95e0-e0b557168ca9" :
        labLogoPath = './LabIcons/lablogo_fajrsari_login.png';
        break;
  
      case "13a28a9b-b3e4-4ab0-ad9c-8dd527c604d6" :
        labLogoPath = './LabIcons/lablogo_salamatmashhad_login.png';
        break;
  
      case "76ac9fec-a20b-4efe-ad6c-fb5c03200509" :
        labLogoPath = './LabIcons/lablogo_zakariarazi_login.png';
        break;
  
      case "c43d7357-5b1e-4715-bf57-87005d46438c" :
        labLogoPath = './LabIcons/lablogo_tehranteb_login.png';
        break;
    
      case "9b085048-f46c-47a8-97ff-edf78e4f4751" :
        labLogoPath = './LabIcons/lablogo_parsgonabad_login.png';
        break;

      case "2fe8181e-0d20-487a-a004-964ce2102762" :
          labLogoPath = './LabIcons/lablogo_parsfoman_login.png';
          break;
    
      case "da5efa36-4618-43e1-a89f-52ec1caf6dce" :
          labLogoPath = './LabIcons/lablogo_parssomehsara_login.png';
          break;
    
      case "f991e6dd-eac0-45d6-b8e1-65066fa34f34" :
          labLogoPath = './LabIcons/lablogo_behsotonkaraj_login.png';
          break;
    
      case "47d9e631-6923-4082-ba1d-f8c69128acad" :
          labLogoPath = './LabIcons/lablogo_baghiatallahshiraz_login.png';
          break;
    
      case "8f68aa8c-a675-4bf5-a176-523bd4721708" :
          labLogoPath = './LabIcons/lablogo_baranrasht_login.png';
          break;
      
      case "6275fd04-5abe-4a82-9e16-0f97ad9bf3d3" :
          labLogoPath = './LabIcons/lablogo_iragen_login.png';
          break;

      case "6f99e248-fd14-4d91-8072-87abb7fa8037" :
            labLogoPath = './LabIcons/lablogo_emamsajadqazvin_login.png';
            break;
      
      case "715aebd1-c64e-4973-9314-cca22fa6459e" :
            labLogoPath = './LabIcons/lablogo_azarahar_login.png';
            break;
      
      ////////////////////////////////////////
      case "abeabdd7-3056-4268-8dac-e13cbb09f532" :
          labLogoPath = './LabIcons/lablogo_abansharyar_login.png';
          break;

      case "6b621e5c-afca-42db-b6b3-dd7861141593" :
          labLogoPath = './LabIcons/lablogo_apadana_login.png';
          break;

      case "b236950c-48d8-4024-877e-5f56970fb18b" :
          labLogoPath = './LabIcons/lablogo_arat_login.png';
          break;

      case "ff305ee3-1d96-4302-9f3a-9676dc67f503" :
          labLogoPath = './LabIcons/lablogo_aryazabolo_login.png';
          break;          

      case "974e690c-7442-460d-a9aa-c16b5084b7e6" :
          labLogoPath = './LabIcons/lablogo_atiyealborz_login.png';
          break;

      case "1e83fa47-cfd8-4a5a-a25a-e4dcf92273de" :
          labLogoPath = './LabIcons/lablogo_attarneishabur_login.png';
          break;

      case "84521256-d498-4d9e-aa39-453cfdeed9c3" :
          labLogoPath = './LabIcons/lablogo_azmon_login.png';
          break;

      case "8f68aa8c-a675-4bf5-a176-523bd4721708" :
          labLogoPath = './LabIcons/lablogo_baranrasht_login.png';
          break;     

      case "10aac3bd-bcc4-4aae-b048-823ffec33ca7" :
          labLogoPath = './LabIcons/lablogo_chekupt_login.png';
          break;

      case "6b6442f1-01e0-43b8-8293-6d75e3caa509" :
          labLogoPath = './LabIcons/lablogo_cheperli_login.png';
          break;

      case "e4e292cb-c22a-4b0b-a00a-3dc0640d3c2d" :
          labLogoPath = './LabIcons/lablogo_danesh_saghez_login.png';
          break;

      case "08a994a7-ea5e-42f0-a569-b859c35c6885" :
          labLogoPath = './LabIcons/lablogo_daneshgorgan_login.png';
          break;          

      case "f2601576-8948-43c0-b8ce-beb1f2251ef5" :
          labLogoPath = './LabIcons/lablogo_daysanandaj_login.png';
          break;

      case "15c03457-ac0d-4a81-af37-3f1d530c4500" :
          labLogoPath = './LabIcons/lablogo_dowlat_login.png';
          break;

      case "70303d51-3aee-4a74-b226-811fccbe450f" :
          labLogoPath = './LabIcons/lablogo_drazari_login.png';
          break;

      case "6ad362c0-a532-41e4-9cf4-f5926ef1454b" :
          labLogoPath = './LabIcons/lablogo_DrBakhshandeh_login.png';
          break;     

      case "9054a0d3-779c-4c47-a546-b9c85dca33a1" :
          labLogoPath = './LabIcons/lablogo_drbaradaran_login.png';
          break;

      case "9a66913e-7f70-4ca4-85a1-6bcaa8dd2fa6" :
          labLogoPath = './LabIcons/lablogo_drfarhamand_login.png';
          break;

      case "4c7b2004-8984-4168-aaab-293d33eeb260","c7b66089-e004-466c-8fee-da99f4db6493" :
          labLogoPath = './LabIcons/lablogo_drfooladi_login.png';
          break;

      case "6328fa17-cb95-4e8c-b412-7585b5847a0d" :
          labLogoPath = './LabIcons/lablogo_drjavadi_login.png';
          break;          

      case "8f32793b-cc1f-4db3-9b99-5cc411c20c4a" :
          labLogoPath = './LabIcons/lablogo_drmalaeknasab_login.png';
          break;

      case "0357b30f-ac6b-44cb-82e3-efa45f0d41f9" :
          labLogoPath = './LabIcons/lablogo_drvahedan_login.png';
          break;

      case "dca63867-6756-441b-95e0-e0b557168ca9" :
          labLogoPath = './LabIcons/lablogo_fajresari_login.png';
          break;

      case "8407d3b0-b52b-4ff7-822e-90973633146e" :
          labLogoPath = './LabIcons/lablogo_farabizafar_login.png';
          break;     

      case "948531cf-a1cb-4a44-acdb-f107aaa9bafe" :
          labLogoPath = './LabIcons/lablogo_farin_login.png';
          break;

      case "E1116FFF-F8E9-4F15-AB0F-9FCCC2B9C2C1" :
          labLogoPath = './LabIcons/lablogo_farredanesh_login.png';
          break;

      case "cfee0c01-f3c0-4cdc-88ca-3812692ac06e" :
          labLogoPath = './LabIcons/lablogo_gharesoran_login.png';
          break;

      case "e97b3b61-c509-41ef-bcee-a0a1b00900a9" :
          labLogoPath = './LabIcons/lablogo_hasanilorestan_login.png';
          break;          

      case "28c0bfa1-8f91-4e49-9610-dd3ce0968f42" :
          labLogoPath = './LabIcons/lablogo_hasanzadeh_login.png';
          break;

      case "56f4bb9a-7f05-4a93-8d8c-e62d08203570" :
          labLogoPath = './LabIcons/lablogo_hayat_login.png';
          break;

      case "943d6a39-4138-424b-8428-65b8de51e6fb" :
          labLogoPath = './LabIcons/lablogo_hossini_login.png';
          break;

      case "cac9e848-e6bf-433d-96a4-b5d5dad751a7" :
          labLogoPath = './LabIcons/lablogo_inanlo_login.png';
          break;    

      case "6275fd04-5abe-4a82-9e16-0f97ad9bf3d3" :
          labLogoPath = './LabIcons/lablogo_iragen_login.png';
          break;

      case "bfe7d9b3-a85b-4a7f-87bb-c453cdd0018d" :
          labLogoPath = './LabIcons/lablogo_Iranmehr_login.png';
          break;

      case "affc7984-bdab-4d12-b0d4-131b68d51837" :
          labLogoPath = './LabIcons/lablogo_javadaeme_login.png';
          break;

      case "ea85acad-8686-4aa3-bc41-2e5bae578da7" :
          labLogoPath = './LabIcons/lablogo_javid_login.png';
          break;          

      case "00c125f8-5e0a-4ef4-8477-6a3a29ce905e" :
          labLogoPath = './LabIcons/lablogo_jeyhani_login.png';
          break;

      case "346f9e2e-b151-4d90-a663-419a94a28721" :
          labLogoPath = './LabIcons/lablogo_Jorjani_login.png';
          break;

      case "cb64fd2f-86ac-4051-a1d5-ff4feb228579" :
          labLogoPath = './LabIcons/lablogo_keshavarz_login.png';
          break;

      case "892ead04-0b0f-4d0d-973b-d7543dbe12f3" :
          labLogoPath = './LabIcons/lablogo_khajekarim_login.png';
          break;     

      case "188df51a-bae9-4b6e-862d-ec23678f098c" :
          labLogoPath = './LabIcons/lablogo_khatam_login.png';
          break;

      case "7252e1cd-4d21-4ab1-b3f0-d90667396d09" :
          labLogoPath = './LabIcons/lablogo_khatamhamedan_login.png';
          break;

      case "ccf461ba-da6b-4154-92c5-971432451dc3" :
          labLogoPath = './LabIcons/lablogo_kheradmand_login.png';
          break;

      case "654857d2-30df-4005-ace3-1308c24184a5" :
          labLogoPath = './LabIcons/lablogo_mahanurmiyeh_login.png';
          break;          

      case "6fb1bd17-75f4-4471-a53f-de92b1be106b" :
          labLogoPath = './LabIcons/lablogo_mahdiekaraj_login.png';
          break;

      case "e87fe0ea-e3da-455f-9be3-9bbb0f3a764f" :
          labLogoPath = './LabIcons/lablogo_mashahir_login.png';
          break;

      case "d7c2e597-8432-45b1-8e33-9a0d5e2114fa" :
          labLogoPath = './LabIcons/lablogo_mehr_tabriz_login.png';
          break;

      case "d42d9793-9f2d-48fb-b077-8a3d0baa1245" :
          labLogoPath = './LabIcons/lablogo_mostafa_mashhad_login.png';
          break;    

      case "f7d36cf4-b2c3-49d4-a100-fbdb928c6bf6" :
          labLogoPath = './LabIcons/lablogo_neginsalamt_login.png';
          break;

      case "effd10cd-ea10-4c3f-ad2e-3fe63e65b61a" :
          labLogoPath = './LabIcons/lablogo_nikan_esfahan_login.png';
          break;

      case "a25679a9-84e1-48c8-a8bd-c9edb7e525cb" :
          labLogoPath = './LabIcons/lablogo_nikanparsian_login.png';
          break;          

      case "9941a3c4-a364-4588-8e07-fbcf79bd2396" :
          labLogoPath = './LabIcons/lablogo_noorhamedan_login.png';
          break;

      case "3a543525-861e-40aa-a375-48582ddbfc06" :
          labLogoPath = './LabIcons/lablogo_novinborojerd_login.png';
          break;

      case "a4721cb2-d366-4bbf-9265-68c889006638" :
          labLogoPath = './LabIcons/lablogo_omidmashhad_login.png';
          break;

      case "74a484be-d205-4268-bcd8-56072c253594" :
          labLogoPath = './LabIcons/lablogo_ostadan_login.png';
          break;     

      case "a46cf170-623f-44c2-80a7-0fcbfbd9b739" :
          labLogoPath = './LabIcons/lablogo_padyab_login.png';
          break;

      case "6aeb5a02-8490-4e80-8a27-301531fafd83" :
          labLogoPath = './LabIcons/lablogo_pardis_golbahar_login.png';
          break;

      case "5d52f52b-a486-4593-8663-9a6993d5d267" :
          labLogoPath = './LabIcons/lablogo_pardis_hafez_login.png';
          break;

      case "05c7c5aa-53a1-41a9-ace3-dd4593ccfbc7" :
          labLogoPath = './LabIcons/lablogo_parsemashhad_login.png';
          break;          

      case "bf2936c9-f390-46ff-a633-17881d59322c" :
          labLogoPath = './LabIcons/lablogo_parsianalborz_login.png';
          break;

      case "538857cb-0109-440b-86bb-baa56453f7e3" :
          labLogoPath = './LabIcons/lablogo_parstehran_login.png';
          break;

      case "9ef42cc1-71af-480e-b082-a14b3cfe18f6" :
          labLogoPath = './LabIcons/lablogo_pazhouhesh_login.png';
          break;

      case "465f0813-6bae-40ec-8e0a-5a26835057ae" :
          labLogoPath = './LabIcons/lablogo_razisharyar_login.png';
          break;    

      case "cf31a52c-6ae5-47fe-9d65-85d7a2528724" :
          labLogoPath = './LabIcons/lablogo_razitehran_login.png';
          break;

      case "69e3d483-edde-42e0-b774-e28696497716" :
          labLogoPath = './LabIcons/lablogo_raziyasoj_login.png';
          break;    

      case "7818230f-631f-43b8-bbba-c19e808b1be1" :
          labLogoPath = './LabIcons/lablogo_rosha_login.png';
          break;

      case "2cb15446-5eda-4c8b-9171-c135089c8476" :
          labLogoPath = './LabIcons/lablogo_sabahashtgerdt_login.png';
          break;    

      case "536f3438-cbc4-4964-8192-4fbb022b0f56" :
          labLogoPath = './LabIcons/lablogo_sabakaraj_login.png';
          break;

      case "e6e8b986-a5f6-4a34-9693-f93ec5191ad0" :
          labLogoPath = './LabIcons/lablogo_sadragorgan_login.png';
          break;    

      case "b66c3ddb-e1a8-4ae1-866a-73d02f4fbd9f" :
          labLogoPath = './LabIcons/lablogo_safatehran_login.png';
          break;

      case "5f6f81b7-28d0-4333-815b-7b43e7e9da4e" :
          labLogoPath = './LabIcons/lablogo_saffar_login.png';
          break;    

      case "9d141639-467f-40f1-bc85-23e129cafcd4","504b3ffd-8c2a-4c5a-b2c5-2e5f085c96f5" :
          labLogoPath = './LabIcons/lablogo_sahebkowsar_login.png';
          break;

      case "13a28a9b-b3e4-4ab0-ad9c-8dd527c604d6" :
          labLogoPath = './LabIcons/lablogo_salamatmashad_login.png';
          break;    

      case "1a34540a-2be1-4c53-b468-9ece1e34b296" :
          labLogoPath = './LabIcons/lablogo_shahidokht_login.png';
          break;

      case "334190f6-4492-4000-8bfb-1e0aba19d217" :
          labLogoPath = './LabIcons/lablogo_soroush_tehran_login.png';
          break;    

      case "ca342303-b966-41b1-8eba-573f477eea01" :
          labLogoPath = './LabIcons/lablogo_taherilab_sirjan_login.png';
          break;

      case "eec3f8eb-7b41-45c1-adcd-ff12adf44188" :
          labLogoPath = './LabIcons/lablogo_tandis_mashhad_login.png';
          break;    

      case "b0010b5c-9e48-4db9-b5a4-a708d6d8221a" :
          labLogoPath = './LabIcons/lablogo_tghizadegan_login.png';
          break;

      case "ccb2ad8b-dda8-44a5-b406-6ccb574e3d37" :
          labLogoPath = './LabIcons/lablogo_vahabzadeh_login.png';
          break;   

      case "9e93318e-6352-4a54-b956-84556412613c" :
          labLogoPath = './LabIcons/lablogo_zagros_marivan_login.png';
          break;   

      ////////////////////////////////////////
      default:
  
        labLogoPath = './LabIcons/lablogo_noidentity_login.png';
        break;
  
    }
  
    return labLogoPath;
  
  }
  